export default {
    'Operation': 'Дія',
    'Sure to delete?': 'Ви впевнені?',
    'Cancel': 'Закрити',
    'Ok': 'Видалити',
};
